import Const from 'constants';
import Action from 'actions';

const PlayerNameStacking = {
    setPlayerNameStackingFromStorage(data) {
        return {
            type: Const.PLAYER_NAME_STACKING_SET_DATA_FROM_STORAGE,
            data,
        };
    },

    usePlayerNameStacking(use) {
        return {
            type: Const.PLAYER_NAME_STACKING_SET_IS_USED,
            use,
        };
    },

    addItemToPlayerNameStacking(item) {
        return (dispatch) => {
            dispatch({
                type: Const.PLAYER_NAME_STACKING_ADD_ITEM,
                item,
            });
            dispatch(this.savePlayerNameStackingToStorage());
        };
    },

    removeItemOfPlayerNameStacking(itemId) {
        return (dispatch) => {
            dispatch({
                type: Const.PLAYER_NAME_STACKING_REMOVE_ITEM,
                itemId,
            });
            dispatch(this.savePlayerNameStackingToStorage());
        };
    },

    savePlayerNameStackingToStorage() {
        return (dispatch) => {
            dispatch(
                this.saveDataToStorage('playerNameStacking', function (state) {
                    const {playerNameStacking} = state;
                    return playerNameStacking.all();
                }),
            );
        };
    },
};

export default Object.assign(Action, PlayerNameStacking);
